export const ROW_HEIGHT = 39;
export const HEADER_INDEX_OFFSET = 1;
export const MIN_WIDTH_FOR_INLINE_EDITING = 1025;
export const ASCENDING = 'asc';
export const DESCENDING = 'desc';
export const SELECT_COLUMN_WIDTH = 32;
export const EXPAND_COLUMN_WIDTH = 42;
export const FILLER_COLUMN_WIDTH = 100;
export const FIELD_TYPE_DROPDOWN = 'dropdown';
export const FIELD_TYPE_DROPDOWN_MULTIPLE = 'FIELD_TYPE_DROPDOWN_MULTIPLE';
export const FIELD_TYPE_STRING = 'string';
export const FIELD_TYPE_NUMBER = 'number';
export const FIELD_TYPE_PASSWORD = 'password';
export const FIELD_TYPE_DATE = 'date';
export const FIELD_TYPE_CONFIRMATION_CHECKBOX = 'confirmationCheckbox';
export const FIELD_TYPE_STATUS_ICON = 'FIELD_TYPE_STATUS_ICON';
export const FIELD_TYPE_ENTITY_LIST = 'FIELD_TYPE_ENTITY_LIST';
export const FIELD_TYPE_LIST = 'list';
export const BULK_EDIT_MODAL_QUERY_STRING_PARAM = 'replace';
export const CREATE_MODAL_QUERY_STRING_PARAM = 'create';
export const EDIT_MODAL_QUERY_STRING_PARAM = 'edit';
export const DELETE_MODAL_QUERY_STRING_PARAM = 'delete';
